import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, mergeProps as _mergeProps, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-12" }
const _hoisted_5 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_6 = { class: "col-md-6" }
const _hoisted_7 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_8 = { class: "col-md-6" }
const _hoisted_9 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_10 = { class: "col-md-12 m-10" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "border border-primary mb-10" }
const _hoisted_13 = { class: "row d-flex align-items-center justify-content-between fw-bold py-2 bg-primary" }
const _hoisted_14 = { class: "col-md-5" }
const _hoisted_15 = { class: "d-flex float-end" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = {
  class: "accordion dark-accordion my-3 py-7",
  id: "magasin"
}
const _hoisted_18 = ["id"]
const _hoisted_19 = ["data-bs-target", "aria-expanded", "aria-controls"]
const _hoisted_20 = ["id", "aria-labelledby"]
const _hoisted_21 = { class: "accordion-body" }
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "col-md-10 mb-2" }
const _hoisted_24 = { class: "" }
const _hoisted_25 = {
  key: 0,
  class: "text-danger mt-1"
}
const _hoisted_26 = { class: "col-md-2" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { class: "border border-primary mb-10" }
const _hoisted_29 = { class: "row gx-0 d-flex align-items-center justify-content-between fw-bold py-2 bg-primary" }
const _hoisted_30 = { class: "col-md-5" }
const _hoisted_31 = { class: "d-flex float-end" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { class: "p-3" }
const _hoisted_34 = { class: "col-md-5" }
const _hoisted_35 = { class: "form-group mb-2" }
const _hoisted_36 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_37 = { class: "col-md-2" }
const _hoisted_38 = { class: "form-group mb-2" }
const _hoisted_39 = ["onUpdate:modelValue"]
const _hoisted_40 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_41 = { class: "col-md-2" }
const _hoisted_42 = { class: "form-group mb-2" }
const _hoisted_43 = ["onUpdate:modelValue"]
const _hoisted_44 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_45 = { class: "col-md-2" }
const _hoisted_46 = { class: "form-group mb-2" }
const _hoisted_47 = ["onUpdate:modelValue"]
const _hoisted_48 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_49 = { class: "col-md-1 mb-1" }
const _hoisted_50 = ["onClick"]
const _hoisted_51 = { class: "col-md-12 mt-3" }
const _hoisted_52 = { class: "d-flex align-items-center" }
const _hoisted_53 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Form, {
        onSubmit: _ctx.addLivraison,
        "validation-schema": _ctx.livraisonSchema,
        "keep-values": _ctx.valuess
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _cache[2] || (_cache[2] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Date de livraison ", -1)),
                _createVNode(_component_Field, {
                  name: "dateLivr",
                  type: "date",
                  value: _ctx.getCurrentDate(),
                  class: "form-control shadow-none fs-md-15 text-black"
                }, null, 8, ["value"])
              ]),
              _createVNode(_component_ErrorMessage, {
                name: "dateLivr",
                class: "text-danger"
              })
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _cache[3] || (_cache[3] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Commande Client "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, { name: "commandeClient" }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, {
                      options: _ctx.commandeOptions,
                      searchable: true,
                      "track-by": "label",
                      label: "label",
                      modelValue: _ctx.selectedCommande,
                      "onUpdate:modelValue": [
                        _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedCommande) = $event)),
                        field.onChange
                      ],
                      value: field.value,
                      placeholder: "Sélectionner la commande"
                    }, null, 8, ["options", "modelValue", "onUpdate:modelValue", "value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "commandeclient",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _cache[4] || (_cache[4] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Livreur "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, { name: "user" }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      options: _ctx.userOptions,
                      searchable: true,
                      "track-by": "label",
                      label: "label",
                      modelValue: field.value,
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                    }, field, { placeholder: "Sélectionner le livreur" }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "user",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "col-md-7" }, [
                      _createElementVNode("h4", { class: "fs-4 text-white" }, "Livraison")
                    ], -1)),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("button", {
                          class: _normalizeClass(["btn btn-success", { 'cursor-not-allowed': _ctx.isDisable }]),
                          type: "button",
                          disabled: _ctx.isDisable,
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addRowMagasin()))
                        }, _cache[5] || (_cache[5] = [
                          _createElementVNode("i", { class: "fa fa-plus-circle position-relative me-1 fs-12" }, null, -1),
                          _createTextVNode("Ajouter un magasin ")
                        ]), 10, _hoisted_16)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_17, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.magasins, (magasin, magasinIndex) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "accordion-item accordion-wrapper",
                          key: magasinIndex
                        }, [
                          _createElementVNode("h2", {
                            class: "accordion-header",
                            id: `magasin${magasinIndex}`
                          }, [
                            _createElementVNode("button", {
                              class: _normalizeClass(`accordion-button bg-light-primary font-primary ${_ctx.magasins.length == magasinIndex+1 ? '' :'collapsed'}`),
                              type: "button",
                              "data-bs-toggle": "collapse",
                              "data-bs-target": `#collapse${magasinIndex}`,
                              "aria-expanded": `${_ctx.magasins.length == magasinIndex+1 ? true :false}`,
                              "aria-controls": `collapse${magasinIndex}`
                            }, [
                              _createTextVNode(_toDisplayString(magasin.nomMagasin ? magasin.nomMagasin: `Magasin ${magasinIndex+1}`) + " ", 1),
                              _cache[7] || (_cache[7] = _createElementVNode("i", {
                                class: "vue-feather vue-feather--chevron-down svg-color",
                                "data-name": "chevron-down",
                                "data-tags": "expand",
                                "data-type": "chevron-down"
                              }, [
                                _createElementVNode("svg", {
                                  xmlns: "http://www.w3.org/2000/svg",
                                  width: "24",
                                  height: "24",
                                  viewBox: "0 0 24 24",
                                  fill: "none",
                                  stroke: "currentColor",
                                  "stroke-width": "2",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  class: "feather feather-chevron-down vue-feather__content"
                                }, [
                                  _createElementVNode("polyline", { points: "6 9 12 15 18 9" })
                                ])
                              ], -1))
                            ], 10, _hoisted_19)
                          ], 8, _hoisted_18),
                          _createElementVNode("div", {
                            class: _normalizeClass(`accordion-collapse collapse ${_ctx.magasins.length == magasinIndex+1 ? 'show' :''}`),
                            id: `collapse${magasinIndex}`,
                            "aria-labelledby": `magasin${magasinIndex}`,
                            "data-bs-parent": "#magasin",
                            style: {}
                          }, [
                            _createElementVNode("div", _hoisted_21, [
                              _createElementVNode("div", _hoisted_22, [
                                _createElementVNode("div", _hoisted_23, [
                                  _createElementVNode("div", _hoisted_24, [
                                    _createVNode(_component_Multiselect, {
                                      options: _ctx.magasinOptions,
                                      searchable: true,
                                      "track-by": "label",
                                      label: "label",
                                      modelValue: magasin.magasin,
                                      "onUpdate:modelValue": ($event: any) => ((magasin.magasin) = $event),
                                      placeholder: "Sélectionner le magasin",
                                      onSelect: ($event: any) => (_ctx.selectMag(magasin.magasin, magasin, magasinIndex))
                                    }, null, 8, ["options", "modelValue", "onUpdate:modelValue", "onSelect"])
                                  ]),
                                  (magasin.erreur)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(magasin.erreur), 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_26, [
                                  _createElementVNode("button", {
                                    class: "btn btn-danger transition border-0 pb-2 ps-8 pe-8",
                                    type: "button",
                                    onClick: ($event: any) => (_ctx.removeRowMagasin(magasinIndex))
                                  }, _cache[8] || (_cache[8] = [
                                    _createElementVNode("i", { class: "fa fa-trash-o lh-1 me-1 position-relative top-2" }, null, -1)
                                  ]), 8, _hoisted_27)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_28, [
                                _createElementVNode("div", _hoisted_29, [
                                  _cache[10] || (_cache[10] = _createElementVNode("div", { class: "col-md-7" }, [
                                    _createElementVNode("h5", { class: "fs-6 mx-1 text-white" }, "Ajouter les produits dans le magasin")
                                  ], -1)),
                                  _createElementVNode("div", _hoisted_30, [
                                    _createElementVNode("div", _hoisted_31, [
                                      _createElementVNode("button", {
                                        class: "btn btn-sm btn-success",
                                        type: "button",
                                        onClick: ($event: any) => (_ctx.addRowProduit(magasinIndex))
                                      }, _cache[9] || (_cache[9] = [
                                        _createElementVNode("i", { class: "fa fa-plus-circle position-relative me-1 fs-12" }, null, -1),
                                        _createTextVNode("Ajouter un produit ")
                                      ]), 8, _hoisted_32)
                                    ])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_33, [
                                  _cache[12] || (_cache[12] = _createElementVNode("div", { class: "row mt-10" }, [
                                    _createElementVNode("div", { class: "col-md-5" }, [
                                      _createElementVNode("label", { class: "d-block text-black fw-semibold" }, [
                                        _createTextVNode(" Produit "),
                                        _createElementVNode("span", { class: "text-danger" }, "*")
                                      ])
                                    ]),
                                    _createElementVNode("div", { class: "col-md-2" }, [
                                      _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                                        _createTextVNode(" Quantité à livrée"),
                                        _createElementVNode("span", { class: "text-danger" }, "*")
                                      ])
                                    ]),
                                    _createElementVNode("div", { class: "col-md-2" }, [
                                      _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Quantité livrée ")
                                    ]),
                                    _createElementVNode("div", { class: "col-md-2" }, [
                                      _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Quantité restante ")
                                    ]),
                                    _createElementVNode("div", { class: "col-md-1" }, [
                                      _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Action ")
                                    ]),
                                    _createElementVNode("hr", { class: "mt-0" })
                                  ], -1)),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(magasin.produits, (produit, produitIndex) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: "row gy-0",
                                      key: produitIndex
                                    }, [
                                      _createElementVNode("div", _hoisted_34, [
                                        _createElementVNode("div", _hoisted_35, [
                                          _createVNode(_component_Multiselect, {
                                            options: magasin.produitOptions,
                                            searchable: true,
                                            "track-by": "label",
                                            label: "label",
                                            modelValue: produit.produit,
                                            "onUpdate:modelValue": ($event: any) => ((produit.produit) = $event),
                                            placeholder: "Sélectionner le produit",
                                            onSelect: ($event: any) => (_ctx.selectProd(produit.produit, produit, magasinIndex))
                                          }, null, 8, ["options", "modelValue", "onUpdate:modelValue", "onSelect"]),
                                          (_ctx.validateRowProduit(produit.produit) )
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_36, " Le produit est obligatoire. "))
                                            : _createCommentVNode("", true)
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_37, [
                                        _createElementVNode("div", _hoisted_38, [
                                          _withDirectives(_createElementVNode("input", {
                                            type: "number",
                                            "onUpdate:modelValue": ($event: any) => ((produit.qtiteALivre) = $event),
                                            class: _normalizeClass(
                                        _ctx.validateRowProduit(produit.qtiteALivre)
                                          ? 'form-control shadow-none fs-md-15 text-black is-invalid'
                                          : 'form-control shadow-none fs-md-15 text-black'
                                      ),
                                            placeholder: "Entrer la quantité",
                                            readonly: ""
                                          }, null, 10, _hoisted_39), [
                                            [_vModelText, produit.qtiteALivre]
                                          ]),
                                          (_ctx.validateRowProduit(produit.qtiteALivre))
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_40, " La quantité à livrée est obligatoire. "))
                                            : _createCommentVNode("", true)
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_41, [
                                        _createElementVNode("div", _hoisted_42, [
                                          _withDirectives(_createElementVNode("input", {
                                            type: "number",
                                            "onUpdate:modelValue": ($event: any) => ((produit.qtiteLivre) = $event),
                                            class: _normalizeClass(
                                        _ctx.validateRowProduit(produit.qtiteLivre)
                                          ? 'form-control shadow-none fs-md-15 text-black is-invalid'
                                          : 'form-control shadow-none fs-md-15 text-black'
                                      ),
                                            placeholder: "Entrer la quantité"
                                          }, null, 10, _hoisted_43), [
                                            [_vModelText, produit.qtiteLivre]
                                          ]),
                                          (_ctx.validateRowProduit(produit.qtiteLivre))
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_44, " La quantité livrée est obligatoire. "))
                                            : _createCommentVNode("", true)
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_45, [
                                        _createElementVNode("div", _hoisted_46, [
                                          _withDirectives(_createElementVNode("input", {
                                            type: "number",
                                            "onUpdate:modelValue": ($event: any) => ((produit.qtiteRestante) = $event),
                                            class: _normalizeClass(
                                        _ctx.validateRowProduit(produit.qtiteRestante ,'qtiteRestante')
                                          ? 'form-control shadow-none fs-md-15 text-black is-invalid'
                                          : 'form-control shadow-none fs-md-15 text-black'
                                      ),
                                            placeholder: "Entrer la quantité"
                                          }, null, 10, _hoisted_47), [
                                            [_vModelText, produit.qtiteRestante]
                                          ]),
                                          (_ctx.validateRowProduit(produit.qtiteRestante , 'qtiteRestante'))
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_48, " La quantité restante est obligatoire. "))
                                            : _createCommentVNode("", true)
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_49, [
                                        _createElementVNode("button", {
                                          class: "btn btn-danger transition border-0 pb-2 ps-8 pe-8",
                                          type: "button",
                                          onClick: ($event: any) => (_ctx.removeRowProduit(magasinIndex, produitIndex))
                                        }, _cache[11] || (_cache[11] = [
                                          _createElementVNode("i", { class: "fa fa-trash-o lh-1 me-1 position-relative top-2" }, null, -1)
                                        ]), 8, _hoisted_50)
                                      ])
                                    ]))
                                  }), 128))
                                ])
                              ])
                            ])
                          ], 10, _hoisted_20)
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_51, [
              _createElementVNode("div", _hoisted_52, [
                _createElementVNode("button", {
                  class: _normalizeClass(["btn btn-success me-3", { 'cursor-not-allowed': _ctx.isDisable }]),
                  type: "submit",
                  disabled: _ctx.isDisable
                }, " Ajouter un livraison ", 10, _hoisted_53),
                _createVNode(_component_router_link, {
                  to: "/livraisons/liste-livraisons",
                  class: "btn btn-danger"
                }, {
                  default: _withCtx(() => _cache[13] || (_cache[13] = [
                    _createElementVNode("i", { class: "fa fa-trash-o lh-1 me-1 position-relative top-2" }, null, -1),
                    _createElementVNode("span", { class: "position-relative" }, null, -1),
                    _createTextVNode("Annuler")
                  ])),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema", "keep-values"])
    ])
  ]))
}